module.exports = __webpack_public_path__ + "static/media/jess_k.941a89de.jpg";